export default __webpack_public_path__ + "static/media/learnAi5Low.a66c23dc.jpg";